import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postCreateMessanger = (params) => {
    return axios.post(`${backendHost}/api/admin/messanger`, params);
};

export {
    postCreateMessanger
}